import { render, staticRenderFns } from "./HyperlinkButton.vue?vue&type=template&id=1233b712&scoped=true&"
import script from "./HyperlinkButton.vue?vue&type=script&lang=js&"
export * from "./HyperlinkButton.vue?vue&type=script&lang=js&"
import style0 from "./HyperlinkButton.vue?vue&type=style&index=0&id=1233b712&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1233b712",
  null
  
)

export default component.exports